import { useEffect, useState, type FormEvent } from 'react';
import { Modal } from '../../../app/components/foundation';
import type { CreateUserPayload } from '../api/users.api';

export interface UserCreateTenantOption {
  id: number;
  name: string;
}

interface UserCreateDialogProps {
  open: boolean;
  tenants: UserCreateTenantOption[];
  submitting: boolean;
  error: string | null;
  onClose: () => void;
  onSubmit: (payload: CreateUserPayload) => Promise<void>;
}

export function UserCreateDialog({
  open,
  tenants,
  submitting,
  error,
  onClose,
  onSubmit,
}: UserCreateDialogProps) {
  const [telegramId, setTelegramId] = useState('');
  const [fullName, setFullName] = useState('');
  const [username, setUsername] = useState('');
  const [phoneNumber, setPhoneNumber] = useState('');
  const [tenantId, setTenantId] = useState('');
  const [isBlocked, setIsBlocked] = useState(false);
  const [validationError, setValidationError] = useState<string | null>(null);

  useEffect(() => {
    if (open) {
      setTelegramId('');
      setFullName('');
      setUsername('');
      setPhoneNumber('');
      setTenantId(tenants[0] ? String(tenants[0].id) : '');
      setIsBlocked(false);
      setValidationError(null);
    }
  }, [open, tenants]);

  if (!open) return null;

  async function handleSubmit(event: FormEvent<HTMLFormElement>) {
    event.preventDefault();
    const parsedTelegramId = Number(telegramId);
    const parsedTenantId = Number(tenantId);
    if (!Number.isInteger(parsedTelegramId) || parsedTelegramId <= 0) {
      setValidationError('شناسه تلگرام باید یک عدد صحیح مثبت باشد.');
      return;
    }
    if (!Number.isInteger(parsedTenantId) || parsedTenantId <= 0) {
      setValidationError('انتخاب تننت الزامی است.');
      return;
    }
    setValidationError(null);
    await onSubmit({
      telegram_id: parsedTelegramId,
      ...(fullName.trim() ? { full_name: fullName.trim() } : {}),
      ...(username.trim() ? { username: username.trim() } : {}),
      ...(phoneNumber.trim() ? { phone_number: phoneNumber.trim() } : {}),
      tenant_id: parsedTenantId,
      is_blocked: isBlocked,
    });
  }

  return (
    <Modal open={open} onClose={onClose} title="افزودن کاربر" className="vania-user-create-modal">
      <form className="vania-user-create-form" onSubmit={handleSubmit}>
        <label>شناسه تلگرام<input dir="ltr" type="number" min="1" value={telegramId} onChange={(event) => setTelegramId(event.target.value)} disabled={submitting} required /></label>
        <label>نام<input value={fullName} onChange={(event) => setFullName(event.target.value)} disabled={submitting} /></label>
        <label>نام کاربری تلگرام<input dir="ltr" value={username} onChange={(event) => setUsername(event.target.value)} disabled={submitting} /></label>
        <label>موبایل<input dir="ltr" value={phoneNumber} onChange={(event) => setPhoneNumber(event.target.value)} disabled={submitting} /></label>
        <label>تننت<select value={tenantId} onChange={(event) => setTenantId(event.target.value)} disabled={submitting || tenants.length === 0} required><option value="">انتخاب کنید</option>{tenants.map((tenant) => <option key={tenant.id} value={tenant.id}>{tenant.name}</option>)}</select></label>
        <label className="vania-user-create-checkbox"><input type="checkbox" checked={isBlocked} onChange={(event) => setIsBlocked(event.target.checked)} disabled={submitting} /> حساب مسدود باشد</label>
        {(validationError || error) ? <p className="vania-user-action-error" role="alert">{validationError || error}</p> : null}
        <div className="vania-user-action-row">
          <button type="button" onClick={onClose} disabled={submitting}>انصراف</button>
          <button type="submit" disabled={submitting || tenants.length === 0}>{submitting ? 'در حال ایجاد…' : 'ایجاد کاربر'}</button>
        </div>
      </form>
    </Modal>
  );
}
